import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';

const List = ({ isReadonly, paymentTypes, enableTermPrice, enableTrials, t, ...rest }) => {
	const columns = [
		{
			header: t('Price_Center'),
			accessor: 'center.name',
			sortable: true
		},
		{
			header: t('Price_Grade'),
			accessor: 'grade.name',
			sortable: true
		},
		{
			header: t('Price_Term'),
			accessor: 'term.name',
			sortable: true
		},
		{
			header: t('Price_PricePerLesson'),
			accessor: 'pricePerLesson',
			cell: (pricePerLesson) => ui.formatAmount(pricePerLesson),
			sortable: true
		}		
	];

	if (paymentTypes.some(p => p.name === 'NormalMonth')) {
		columns.push({
			header: t('Price_FourLessonPackagePricePerLesson'),
			accessor: 'fourLessonPackagePricePerLesson',
			cell: (fourLessonPackagePricePerLesson) => ui.formatAmount(fourLessonPackagePricePerLesson),
			sortable: true
		});
	}

	if (paymentTypes.some(p => p.name === 'NormalSingle')) {
		columns.push({
			header: t('Price_SingleLessonPrice'),
			accessor: 'singleLessonPrice',
			cell: (singleLessonPrice) => ui.formatAmount(singleLessonPrice),
			sortable: true
		});
	}

	if (paymentTypes.some(p => p.name === 'Annual')) {
		columns.push({
			header: t('Price_AnnualPrice'),
			accessor: 'annualPrice',
			cell: (annualPrice) => ui.formatAmount(annualPrice),
			sortable: true
		});
	}

	if (enableTermPrice) {
		columns.push({
			header: t('Price_TermPrice'),
			accessor: 'termPrice',
			cell: (termPrice) => termPrice !== null? ui.formatAmount(termPrice): 'N/A',
			sortable: true
		});
	}

	if (enableTrials) {
		columns.push({
			header: t('Price_TrialLessonPrice'),
			accessor: 'trialLessonPrice',
			cell: (trialLessonPrice) => trialLessonPrice !== null ? ui.formatAmount(trialLessonPrice) : t('Price_UseCenterDefault'),
			sortable: true
		});
	}
	columns.push({
		header: t('Common_Actions'),
		accessor: 'id',
		cell: (id) => (<Link to={`/prices/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={isReadonly ? faEye : faEdit} /> {t(isReadonly ? 'Common_View' : 'Common_Edit')}</Link>)
	});

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={!isReadonly && <NewButton newItemPath='/prices/new' />} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);